import { compose, equals, gt, includes, isEmpty, length, not, prop, propOr } from 'ramda';

// Valeurs de IND_SELECT_MULTIPLE_OPTION portées par la ligne formule du moteur PREV_COLL_PRODUCT
export const OPTION_SELECTION_MODE = {
  UNIQUE_REQUIRED: 'UNIQUE_OBLIGATOIRE',
  UNIQUE_OPTIONAL: 'UNIQUE_FACULTATIF'
};

const UNIQUE_MODES = [OPTION_SELECTION_MODE.UNIQUE_REQUIRED, OPTION_SELECTION_MODE.UNIQUE_OPTIONAL];

// Plusieurs options possibles tant que le mode n'impose pas une option unique
export const isOptionSelectionMultiple = (mode) => not(includes(mode, UNIQUE_MODES));

export const isOptionSelectionRequired = (mode) =>
  equals(OPTION_SELECTION_MODE.UNIQUE_REQUIRED, mode);

/**
 * Vérifie le nombre d'options choisies au regard du mode de sélection de la formule.
 *
 * - UNIQUE_OBLIGATOIRE : exactement 1 option si la formule en propose ;
 * - UNIQUE_FACULTATIF : 0 ou 1 option ;
 * - autre valeur ou vide : 0..n options.
 *
 * @param {{ optionSelectionMode?: string, options?: Array<object> }} formula
 * @param {Array<string>} optionCodes
 * @returns {boolean}
 */
export const validateOptionSelection = (formula, optionCodes) => {
  const mode = prop('optionSelectionMode', formula);
  const selectedCount = length(optionCodes ?? []);
  const hasOptions = compose(not, isEmpty, propOr([], 'options'))(formula);

  if (equals(OPTION_SELECTION_MODE.UNIQUE_REQUIRED, mode)) {
    return equals(hasOptions ? 1 : 0, selectedCount);
  }

  if (equals(OPTION_SELECTION_MODE.UNIQUE_OPTIONAL, mode)) {
    return not(gt(selectedCount, 1));
  }

  return true;
};

export default validateOptionSelection;
